import { render, staticRenderFns } from "./MediaVerticalList.vue?vue&type=template&id=97dd7e2e&scoped=true"
import script from "./MediaVerticalList.vue?vue&type=script&lang=js"
export * from "./MediaVerticalList.vue?vue&type=script&lang=js"
import style0 from "./MediaVerticalList.vue?vue&type=style&index=0&id=97dd7e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dd7e2e",
  null
  
)

export default component.exports